module.exports = __webpack_public_path__ + "img/logo-ecartapi.c5fd1eac.svg";